import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Orders from "./orders";
ReactSession.setStoreType("localStorage");

const OrderDetails = () => {
    const navigate = useNavigate();
    const userId=ReactSession.get("welbeingId");

    const queryParameters = new URLSearchParams(window.location.search)
    const orderId = queryParameters.get("id");
   
console.log(orderId);

    const location = useLocation();
    const [order, setOrder] = useState(location.state?.order || null);
    console.log(order);
    const [loading, setLoading] = useState(!location.state?.order);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState('');
    if(userId  <= 0 ){
      navigate('/login');
   }

console.log("order",order)

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const response = await axios.post(
                    "https://api.welbeing.in/orders/order/", {order_id: orderId}

                );
                console.log("gateway:", response.data.data.gateway);
               
                
                setOrder(response.data.data);
            } catch (error) {
                console.error("Failed to fetch order details", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        if (!order && orderId) {
            fetchOrderDetails();
        }
        fetchOrderDetails();
    }, [orderId, order]);

    if (loading) {
        return (
            <>
                <Header />
             
                <div className="container-fluid" style={{ paddingLeft: '280px' }}>
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Header />
                
                <div className="container-fluid" style={{ paddingLeft: '280px' }}>
                    <div className="alert alert-danger mt-3">
                        Error: {error}
                    </div>
                </div>
            </>
        );
    }

    if (!order) {
        return (
            <>
                <Header />
              
                <div className="container-fluid" style={{ paddingLeft: '280px' }}>
                    <div className="alert alert-warning mt-3">
                        No order found for ID: {orderId}
                    </div>
                </div>
            </>
        );
    }

     const handleStatusChange = (e) => {
          e.preventDefault();
        const selectedStatus = e.target.value;
        setStatus(selectedStatus);        
    };


    const updateStatus =async() =>{
        try {
                const response = await axios.post("http://localhost/projects/welbeing-admin-api/order/update-status/", 
                    {status:status,order_id: orderId}                  

                );
                 if(response.data.status==='success'){
                    alert("Order Status Updated ")
                        
                    }
                
            } catch (error) {
                console.error("Failed to update order status", error);
                setError(error.message);}

    }


    return (
        <>
            <Header />
           
            <div className="container-fluid">
                <div className="card bg-light-info shadow-none position-relative overflow-hidden">
                    <div className="card-body px-4 py-3" style={{ marginLeft: '280px' }}>
                        <div className="row align-items-center">
                            <div className="col-9">
                                <h4 className="fw-semibold mb-8">Order Details #{order.order_id || orderId}</h4>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a className="text-muted" href="/orders">Orders</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Order Details
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-3">
                                <div className="text-center mb-n5">
                                    <img src="dist/images/breadcrumb/ChatBc.png" alt="" className="img-fluid mb-n4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section>
                    <div className="row">
                        <div className="col-12">
                            <div className="card" style={{ marginLeft: '280px' }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table border">
                                                            <thead className="bg-primary text-white">
                                                                <tr>
                                                                    <th colSpan="2">Delivery Details</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td width="65%">
                                                                        <p>
                                                                            <b>{order.name || 'N/A'}</b><br />
                                                                            {order.address || 'N/A'}<br />
                                                                            <b>{order.phonenumber || 'N/A'}</b><br />
                                                                            {order.email || 'N/A'}
                                                                        </p>
                                                                        <p>Delivery Notes<br />{order.comments || 'N/A'}</p>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table border">
                                                            <thead className="bg-primary text-white">
                                                                <tr>
                                                                    <th colSpan="2">Payment Details</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td width="65%">
                                                                        <p>
                                                                            Amount: ₹ {Number(order.grand_total).toFixed(2) || '0.00'}<br />
                                                                            Payment ID: {order.payment_id || 'N/A'}<br />
                                                                            Payment Status: {order.pay_status || 'N/A'}<br />
                                                                            Payment Mode: {order.payment_mode || 'N/A'}
                                                                        </p>
                                                                    </td>
                                                                    <td style={{ verticalAlign: 'bottom' }}>
                                                                       <div className="form-body">
                                                                           <div className="row">
                                                                               <div className="col-md-12">
                                                                                   <div className="mb-3">
                                                                                       <input type="hidden" value={order.order_id} name="id" />
                                                                                       <label>Order Status</label>
                                                                                       <select
                                                                                           className="form-control"
                                                                                           name="status"
                    
                                                                                           value={order.status||''} 
                                                                                           onChange={handleStatusChange}
                                                                                       >
                                                                                           <option value="Order Placed">Order Placed</option>
                                                                                           <option value="Shipped">Shipped</option>
                                                                                           <option value="Delivered">Delivered</option>
                                                                                           <option value="Cancelled">Cancelled</option>
                                                                                       </select>
                                                                                   </div>
                                                                               </div>
                                                                           </div>
                                                                       </div>
                                                                       <div>
                                                                           <div className="text-start">
                                                                               <button
                                                                                   className="btn btn-light-primary text-primary font-medium"
                                                                                   onClick={() => updateStatus()}
                                                                               >
                                                                                   Update
                                                                               </button>
                                                                           </div>
                                                                       </div>

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table border">
                                                            <thead className="bg-primary text-white">
                                                                <tr>
                                                                    <th colSpan="2">Product</th>
                                                                    <th className="text-center">Color</th>
                                                                    <th className="text-center">Design</th>
                                                                    <th className="text-center">Quantity</th>
                                                                    <th className="text-end">Price</th>
                                                                    <th className="text-end">Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {order?.order_details?.length > 0 ? (
                                                                    <>
                                                                    {order?.order_details?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-start">
                                                                                {item.img && (
                                                                                    <img 
                                                                                        src={`https://api.welbeing.in/admin/product_data/${item.img}`} 
                                                                                        alt={item.product} 
                                                                                        width="50px" 
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                            <td >
                                                                                {item.product || 'N/A'}<br />
                                                                                <small>{item.product_id || ''}</small>
                                                                            </td>
                                                                            {item.color ? (
                                                                            <td style={{ display: 'flex', alignItems: 'center' }} className="text-center">
                                                                                
                                                                                    <>
                                                                                        <div 
                                                                                            className="text-center" 
                                                                                            style={{ 
                                                                                                width: '40px', 
                                                                                                height: '40px', 
                                                                                                borderRadius: '10px', 
                                                                                                marginRight: '10px',
                                                                                                backgroundColor: item.code || '#ccc'
                                                                                            }}
                                                                                        ></div>
                                                                                        <small>{item.color}</small>
                                                                                    </>
                                                                                
                                                                            </td>): (<td className="text-center">{item.color || 'N/A'}</td>)}
                                                                            <td className="text-center">{item.design || 'N/A'}</td>
                                                                            <td className="text-center">{item.quantity || '0'}</td>
                                                                            <td className="text-end">₹ {Number(item.price).toFixed(2) || '0.00'}</td>
                                                                            <td className="text-end">₹ {Number(item.price * item.quantity).toFixed(2)  || '0.00'}</td>
                                                                        </tr>
                                                                    ))}
                                                                    <tr>
                                                                        <td colSpan={5}></td>
                                                                        <td className="text-end">Sub Total</td>
                                                                        <td className="text-end">₹ {Number(parseFloat(order?.grand_total) + parseFloat(order?.discount) - parseFloat(order?.shipping)).toFixed(2)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={5}></td>
                                                                        <td className="text-end">Discount</td>
                                                                        <td className="text-end">- ₹ {Number(order?.discount).toFixed(2)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={5}></td>
                                                                        <td className="text-end">Shipping</td>
                                                                        <td className="text-end">₹ {Number(order?.shipping).toFixed(2)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={5}></td>
                                                                        <th className="text-end">Grand Total</th>
                                                                        <th className="text-end">₹ {Number(order?.grand_total).toFixed(2)}</th>
                                                                    </tr>
                                                                    </>
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="6" className="text-center">
                                                                            No items found in this order
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default OrderDetails;